/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const incidentCustomerCommandVersionExclusiveMin = 0;
export const incidentCustomerCommandVersionMax = 9007199254740991;

export const incidentCustomerCommandCustomerIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);

export const IncidentCustomerCommand = zod.object({
  version: zod
    .int()
    .gt(incidentCustomerCommandVersionExclusiveMin)
    .max(incidentCustomerCommandVersionMax),
  customerId: zod.uuid().regex(incidentCustomerCommandCustomerIdRegExp),
});

export type IncidentCustomerCommand = zod.input<typeof IncidentCustomerCommand>;
export type IncidentCustomerCommandOutput = zod.output<typeof IncidentCustomerCommand>;
